<template>
  <a :href="href" target="_blank" class="button t-text t-text--small t-bold u-white u-inline-block" :style="{backgroundColor: color}">
    {{ label }}
  </a>
</template>

<script>
export default {
  name: 'Cta',

  props: {
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.button
  cursor pointer
  padding 9px 22px
  border-radius 100px
</style>